module.exports = __webpack_public_path__ + "img/DashboardHeroImage.4d72378d.png";